import { Modal } from "antd";
import "./loginmodal.scss";
import SvgLogo from "../../icons/SvgLogo";
import SvgCloseRound from "../../icons/SvgCloseRound";
import InputPhone from "../../packages/InputPhone/InputPhone";
import { useEffect, useState } from "react";
import OtpInput from "react-otp-input";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import {
  loginUserMiddleWare,
  verifyOTPMiddleWare,
} from "./store/loginMiddleware";
import { setLoader } from "../../redux/store/commonReducer";
import LoginDetails from "./LoginDetails";
import { toast } from "react-toastify";
import { setLoginUser } from "./store/loginReducer";

const mapStateToProps = (state) => {
  const { loginUserReducers } = state;
  return {
    mobileData: loginUserReducers.data,
  };
};

const LoginModal = ({
  open,
  onHide,
  mobileData,
  isKundli,
  handleGetKundali,
  redirectPath = "",
}) => {
  const [isOtpVisible, setOtpVisible] = useState(false);
  const [otp, setOtp] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [timer, setTimer] = useState(120);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoginDetailVisible, setLoginDetailVisible] = useState(false);

  useEffect(() => {
    let interval;
    if (timer > 0 && isOtpVisible) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timer, isOtpVisible]);

  const handleSend = () => {
    dispatch(setLoader(true));
    const payload = {
      mobileNumber: parseInt(mobileNo.substring(2)),
      appId: "ASTROVIDHI UHnBefGKucK",
      memberType: "User",
    };
    dispatch(loginUserMiddleWare(payload))
      .then((res) => {
        if (res.payload?.response?.data?.message === "Fail") {
          toast.error(res.payload?.response?.data?.alert, {
            position: "top-center",
          });
        } else {
          dispatch(setLoginUser(parseInt(mobileNo.substring(2))));
          toast.info(`OTP send  to ${mobileNo.substring(2)} `, {
            position: "bottom-center",
            theme: "dark",
          });
          setOtpVisible(true);
        }
      })
      .finally(() => dispatch(setLoader(false)));
  };

  const formattedTime = () => {
    const minutes = Math.floor(timer / 60);
    const seconds = timer % 60;
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  const handleResendOTP = () => {
    setTimer(120);
    dispatch(setLoader(true));
    const payload = {
      mobileNumber: parseInt(mobileNo.substring(2)),
      appId: "ASTROVIDHI UHnBefGKucK",
      memberType: "User",
    };
    dispatch(loginUserMiddleWare(payload))
      .then(() => {
        toast.success("OTP send successfully", {
          position: "top-center",
        });
      })
      .finally(() => dispatch(setLoader(false)));
  };

  const handleLogin = () => {
    dispatch(setLoader(true));
    const payload = {
      mobileNumber: Number(mobileData?.mobileNumber),
      otp: Number(otp),
    };
    dispatch(verifyOTPMiddleWare(payload))
      .then((res) => {
        if (res.payload?.response?.data?.message === "Fail") {
          toast.error(res.payload?.response?.data?.alert, {
            position: "top-center",
          });
        } else if (res?.payload?.data?.newUser) {
          toast.success("OTP verified successfully ", {
            position: "top-center",
          });
          setLoginDetailVisible(true);
        } else {
          toast.success("Login Successfully", {
            position: "top-center",
          });
          const loginDetails = JSON.stringify(res.payload);
          localStorage.setItem("user", loginDetails);
          localStorage.setItem("isLoggedIn", true);
          onHide();
          if (isKundli && redirectPath == "") {
            window.location.replace("/#/kundali");
            if (handleGetKundali) {
              handleGetKundali();
            }
          } else if (redirectPath !== "") {
            navigate(redirectPath);
          } else {
            window.location.reload();
          }
        }
      })
      .finally(() => dispatch(setLoader(false)));
  };
  if (!isOtpVisible) {
    return (
      <Modal
        footer={null}
        centered
        open={open}
        className="modal-wrapper-container"
        closeIcon={<SvgCloseRound />}
        onCancel={() => onHide()}
      >
        <div className="login-modal-container">
          <div className="signup-text-first">Sign up / Login</div>
          <div className="logo-div">
            <SvgLogo width={248} height={77} />
            <span className="signup-text">Sign up / Login</span>
          </div>
          <div className="phone-input-div">
            <label htmlFor="mobileNumber">Mobile Number</label>
            <InputPhone setValue={setMobileNo} value={mobileNo} />
          </div>
          <button
            className="btn pointer"
            onClick={handleSend}
            disabled={!mobileNo || mobileNo.length < 12}
          >
            Send OTP
          </button>
          <p className="login-info-msg">
            By Signing up, you agree to our{" "}
            <span
              onClick={() => {
                navigate("/terms-and-conditions");
              }}
            >
              Terms of Use
            </span>{" "}
            and{" "}
            <span
              onClick={() => {
                navigate("/privacy-policy");
              }}
            >
              Privacy Policy
            </span>
          </p>
        </div>
      </Modal>
    );
  }

  if (isOtpVisible && !isLoginDetailVisible) {
    return (
      <Modal
        footer={null}
        centered
        open={open}
        closeIcon={<SvgCloseRound />}
        onCancel={() => onHide()}
        className="modal-wrapper-container"
      >
        <div className="login-modal-container">
          <div className="title-div">
            <span>Verify Otp</span>
          </div>
          <div className="logo-div mar-top-30">
            <span className="signup-text">
              OTP sent to +91-{mobileNo.slice(2)}
            </span>
          </div>
          <div className="phone-input-div">
            <OtpInput
              value={otp}
              onChange={setOtp}
              numInputs={6}
              renderSeparator={""}
              renderInput={(props) => <input {...props} />}
              inputStyle="otp-container"
              containerStyle={{ gap: "20px", justifyContent: "center" }}
              inputType="number"
            />
          </div>
          <div className="send-otp">
            {timer > 0 && (
              <span style={{ fontFamily: "Poppins-Regular", fontSize: 16 }}>
                {formattedTime()}
              </span>
            )}
            <button
              disabled={timer > 0}
              className="send-otp-btn pointer"
              onClick={handleResendOTP}
            >
              Send Otp Again
            </button>
          </div>
          <button
            className="btn pointer mar-btm-30 primary"
            onClick={handleLogin}
            disabled={!Boolean(otp.length === 6)}
          >
            Login
          </button>
        </div>
      </Modal>
    );
  }

  return (
    <LoginDetails
      visible={isLoginDetailVisible}
      onclose={() => {
        setLoginDetailVisible(false);
        setOtpVisible(false);
        onHide(false);
      }}
    />
  );
};

export default connect(mapStateToProps)(LoginModal);
